const analyticsGlobal = globalThis as typeof globalThis & {
  digitalData: Window['digitalData']
}

/** Initializes the digitalData object structure Adobe Launch reads from. */
export const initializeDigitalData = (): void => {
  analyticsGlobal.digitalData ??= {}

  analyticsGlobal.digitalData.page = analyticsGlobal.digitalData.page || {}
  analyticsGlobal.digitalData.user = analyticsGlobal.digitalData.user || {}
  analyticsGlobal.digitalData.site = analyticsGlobal.digitalData.site || {}
  analyticsGlobal.digitalData.event = analyticsGlobal.digitalData.event || {}
}

/** Updates page information ahead of a page-view track call. */
export const setPageInfo = (
  pageName: string,
  pageData?: {
    pageTemplate?: string
    pageType?: string
    contentTitle?: string
    contentType?: string
  }
): void => {
  if (!analyticsGlobal.digitalData) initializeDigitalData()

  analyticsGlobal.digitalData!.page = {
    ...analyticsGlobal.digitalData!.page,
    pageInfo: {
      page: pageName,
      pageNameGranular: pageName,
      pageName: pageName.split(':').pop() || pageName,
      pageTemplate: pageData?.pageTemplate || '',
      pageType: pageData?.pageType || '',
      previousPage: sessionStorage.getItem('previousPage') || '',
      previousLink: document.referrer,
      ...pageData,
    },
  }

  sessionStorage.setItem('previousPage', pageName)
}

/** Updates user information, sourced from Redux profile/role state. */
export const setUserInfo = (userData: {
  nuid?: string
  region?: string
  loginState?: 'Authenticated' | 'Unauthenticated'
  userType?: string
  jobRole?: string
  employeeTenure?: string
  union?: string
  workforceClass?: string
}): void => {
  if (!analyticsGlobal.digitalData) initializeDigitalData()

  analyticsGlobal.digitalData!.user = {
    ...analyticsGlobal.digitalData!.user,
    userID: userData.nuid || '',
    loginState: userData.loginState || 'Unauthenticated',
    userType: userData.userType || '',
    profile: {
      region: userData.region || '',
    },
    job: {
      jobRole: userData.jobRole || '',
    },
    employee: {
      union: userData.union || '',
      workforceClass: userData.workforceClass || '',
      employeeTenure: userData.employeeTenure || '',
    },
    timestamp: new Date().toISOString(),
    userKnown: !!userData.nuid,
  }
}

/** Sets the fixed site-level info shared by every TORT page view. */
export const setSiteInfo = (): void => {
  if (!analyticsGlobal.digitalData) initializeDigitalData()

  analyticsGlobal.digitalData!.site = {
    siteName: 'kporg',
    domain: 'kp',
    subdomain: 'mykp',
    language: 'en',
    charSet: 'UTF-8',
    applicationName: 'tort',
  }
}

/** Updates page content metadata ahead of a page-view track call. */
export const setContentInfo = (contentData: {
  title?: string
  type?: string
}): void => {
  if (!analyticsGlobal.digitalData) initializeDigitalData()

  analyticsGlobal.digitalData!.page = {
    ...analyticsGlobal.digitalData!.page,
    content: {
      title: contentData.title || '',
      type: contentData.type || 'page',
    },
  }
}
